/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import AppsIcon from '@mui/icons-material/Apps';
import StorageIcon from '@mui/icons-material/Storage';
import BackupIcon from '@mui/icons-material/Backup';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import SecurityIcon from '@mui/icons-material/Security';
import WidgetsIcon from '@mui/icons-material/Widgets';
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import PodPage from "views/Dashboard/Pod.js";
import HelmPage from "views/Dashboard/Helm.js";
import DocsPage from "views/Dashboard/Docs.js";
import CertificatePage from "views/Dashboard/Certificate.js";
import BackupPage from "views/Dashboard/Backup.js";
import SystemLogs from "views/Dashboard/SystemLogs.js";
import RawBackupDetailPage from "views/Dashboard/RawBackupDetail.js";
import BackupDetailPage from "views/Dashboard/BackupDetail.js";
import AppsPage from "views/Dashboard/Apps.js";
import ChangePassword from "layouts/authentication/password";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: DashboardPage,
    layout: "/admin"
  },
  {
    path: "/pods",
    name: "Pods",
    icon: StorageIcon,
    component: PodPage,
    layout: "/admin"
  },
  {
    path: "/helms",
    name: "Helm Charts",
    icon: AppsIcon,
    component: HelmPage,
    layout: "/admin"
  },
  {
    path: "/certificates",
    name: "Certificates",
    icon: SecurityIcon,
    component: CertificatePage,
    layout: "/admin"
  },
  {
    path: "/backups",
    name: "Backups",
    icon: BackupIcon,
    component: BackupPage,
    layout: "/admin"
  },
  {
    path: "/rawbackups/:id",
    name: "Raw Backups Detail",
    icon: BackupOutlinedIcon,
    component: RawBackupDetailPage,
    layout: "/admin"
  },
  {
    path: "/backup/:id",
    name: "Backups Detail",
    icon: BackupIcon,
    component: BackupDetailPage,
    layout: "/admin"
  },
  {
    path: "/apps",
    name: "Apps",
    icon: WidgetsIcon,
    component: AppsPage,
    layout: "/admin"
  },
  {
    path: "/logs",
    name: "Logs",
    icon: BackupIcon,
    component: SystemLogs,
    layout: "/admin"
  },
  {
    path: "/changepassword",
    name: "Change Password",
    icon: DescriptionIcon,
    component: ChangePassword,
    layout: "/pwd"
  }
];

export default dashboardRoutes;
